import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { IAttribute, IModel } from '../base/annotation';

@Metamodel.model({})
export class StoreSettingMetadata extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly NAME: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['String'],
        association: 'NAME'
    })
    public name: string;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['String'],
        association: 'VALUE'
    })
    public value: string;
}
